import { from } from 'rxjs'

export { NotFoundPage } from './not-found.page';
